import { HexColor } from '@nx-smartmonkey/shared/domain';
import { AvatarIcon, RoutalAvatarColorPicker } from '@nx-smartmonkey/ui';
import React from 'react';

import { getRouteColor } from '../constants/Colors';
import { Driver } from '../domain/driver/Driver';
import useRetrieveVehicleAvatar from '../hooks/vehicle/useRetrieveVehicleAvatar';

interface RouteAvatarProps {
  driver: Driver;
  color?: string;
  planDrivers?: Driver[];
  additionalStyles?: React.CSSProperties;
  withColorPicker?: boolean;
  onUpdate?: (color: HexColor) => void;
}

export const RouteAvatar = ({
  driver,
  color,
  planDrivers = [],
  additionalStyles = {},
  withColorPicker = false,
  onUpdate = () => {},
}: RouteAvatarProps) => {
  const { data: vehicleAvatar } = useRetrieveVehicleAvatar({ vehicleId: driver.vehicle_id });

  const routeColor = getRouteColor(driver, planDrivers);

  if (withColorPicker) {
    return (
      <RoutalAvatarColorPicker
        color={color ?? routeColor}
        avatar={vehicleAvatar}
        colorSampleStyles={additionalStyles}
        onUpdate={(newColor: string) => {
          if (onUpdate) {
            onUpdate(HexColor.create(newColor));
          }
        }}
      />
    );
  }

  return (
    <>
      {vehicleAvatar ? (
        <img
          draggable="false"
          src={vehicleAvatar}
          alt="vehicle_avatar"
          style={{
            border: `2px solid ${color ?? routeColor}`,
            width: `calc(24px - 4px)`,
            height: `calc(24px - 4px)`,
            borderRadius: `50%`,
            ...additionalStyles,
          }}
        />
      ) : (
        <AvatarIcon
          color={color ?? routeColor}
          style={{
            width: `24px`,
            height: `24px`,
            ...additionalStyles,
          }}
        />
      )}
    </>
  );
};

export default RouteAvatar;
